import React from 'react';
import Toolbar from '../toolbar';
import ProfilePicture from "profile-picture"
import "profile-picture/build/ProfilePicture.css"
import {   TextField ,Fab} from '@material-ui/core';
import {Button, FormControl,Modal} from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import {Navbar,Nav,Form} from 'react-bootstrap';

export default class Contact extends React.Component{

render(){
    return (
        <div style={{backgroundColor:"black",height:"860px"}}>

<Toolbar/>
<Navbar bg="dark" variant="dark" style={{fontSize:'18px'}}>
      <Nav className="mr-auto">
        <Nav.Link href="/create_portfolio1" >Home</Nav.Link>
        <Nav.Link href="/create_portfolio1/about">About</Nav.Link>
        <Nav.Link href="/create_portfolio1/work">Work</Nav.Link>
      </Nav>
      <Form inline style={{fontSize:'18px'}}>
       	&nbsp;&nbsp;
        <a style={{color:"white"}} active href="/create_portfolio1/contact" style={{fontSize:'18px'}}>Contact</a>
      </Form>
    </Navbar>

</div>
    )
}
}